import _map from "lodash/map"
import _filter from "lodash/filter"

import { POSPAGO, PRODUCTSTATUS } from "services/state/billing/constants"
import { getInactiveDates, getActiveDates } from "./handleDates"

import moment from "moment"
import "moment/locale/pt-br"
moment.locale("pt-br")

export const getMonthsDetailingFiltered = (productDetails, invoices) => {
  let invoicesFiltered = []

  if (productDetails.paymentMode === POSPAGO) {
    invoicesFiltered = invoicesPosPaid(invoices)
  } else {
    invoicesFiltered = invoicesPrePaid(productDetails)
  }

  return invoicesFiltered
}

const invoicesPosPaid = (accountInvoices) => {
  const invoicesDetails = _filter(accountInvoices, { details: "SIM" })

  return _map(invoicesDetails, (invoice) => {
    return {
      paymentDate: moment(invoice.dueDate, "DD/MM/YYYY").format("MM/YYYY"),
      invoiceKey: moment(invoice.dueDate, "DD/MM/YYYY").format("YYYYMM")
    }
  })
}

const invoicesPrePaid = (productDetail) => {
  const { productStatus } = productDetail
  const disconnectDate = moment(productDetail.disconnectDate, "DD/MM/YYYY")
  const activationDate = moment(productDetail.activationDate, "DD/MM/YYYY")

  if (productStatus === PRODUCTSTATUS.INATIVO) {
    return getInactiveDates(activationDate, disconnectDate)
  }

  return getActiveDates(activationDate)
}



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/getMonthsDetailingFiltered.js